<!--

  @copyright Copyright (c) Open-Xchange GmbH, Germany <info@open-xchange.com>
  @license AGPL-3.0

  This code is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with OX App Suite. If not, see <https://www.gnu.org/licenses/agpl-3.0.txt>.

  Any use of the work other than as authorized under this license or copyright law is prohibited.

-->

<template>
  <li class="category-browser-mail-item" aria-hidden="true" data-detail-popup="mail" :data-cid="data.cid">
    <div class="icon-container" ref="iconContainerNode"></div>
    <div class="info-container">
      <div v-html="callExtensions(['from', 'date'], { data })" class="list-item-row flex-row"></div>
      <div ref="row2ContainerNode" class="list-item-row flex-row"></div>
      <BadgeList :limit="3" :collection="data.user"/>
    </div>
  </li>
</template>

<script setup>
import mailExtensions from '@/io.ox/mail/common-extensions'
import ext from '@/io.ox/core/extensions'
import $ from '@/jquery'
import { ref, onMounted } from 'vue'
import folderAPI from '@/io.ox/core/folder/api'
import BadgeList from '@/io.ox/core/categories/browser/badge-list.vue'

const { data } = defineProps(['data'])

function callExtensions (extensions, data) {
  return extensions.reduce((processedExtensions, currentExtension) => processedExtensions + callExtension(currentExtension, data), '')
}

function callExtension (extension, data) {
  const tempNode = $('<div>')
  mailExtensions[extension].call(tempNode, new ext.Baton(data))
  return tempNode.html()
}

// render elements that are not part of the template. Backbone views etc
const iconContainerNode = ref()
const row2ContainerNode = ref()
onMounted(() => {
  mailExtensions.subject.call($(row2ContainerNode.value), new ext.Baton({ data }))
  folderAPI.get(data.original_folder_id).then(folder => $(row2ContainerNode.value).append($('<div class="folder">').text(folder.title)))
  mailExtensions.unread.call($(iconContainerNode.value), new ext.Baton({ data }))
  mailExtensions.paperClip.call($(iconContainerNode.value), new ext.Baton({ data }))
})
</script>

<style lang="scss">
.category-browser-mail-item {
  cursor: pointer;
  padding: 8px 16px 8px 0;
  display: flex;
  height: 72px;

  .icon-container {
    padding: 0 4px 0 4px;
    display: flex;
    flex-flow: column;
    width: 32px;
    flex-grow: 0;
    flex-shrink: 0;

    svg {
      height: 20px;
      width: 20px;
    }

    .seen-unseen-indicator {
      margin-left: 5px;
      width: 11px;
      color: var(--unseen)
    }

    .has-attachments {
      padding: 2px 0;
      color: var(--text)
    }
  }

  .info-container {
    width: calc(100% - 32px);
  }

  .list-item-row {
    gap: 4px;
    height: 16px;
  }

  .folder {
    background-color: var(--gray-100);
    height: 18px;
    line-height: 18px;
    padding: 0 4px;
    border-radius: 6px;
    color: var(--gray-800);
  }

  .subject, .from {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .from { font-weight: bold; }
  .subject { color: var(--text-gray); }
  &:focus {
    .has-attachments,.subject {color: var(--selected-focus)};
  }

  .categories-badges .category-view {
    line-height: 18px;
    height: 18px;
    margin-top: 4px;
    border-radius: 6px;
    padding-inline: 4px;
  }
}
</style>
